import axiosInstance from "../../../utils/axios";
import { ROLE } from "../../../utils/Constants";
const options = { role: ROLE.SUPER_ADMIN };

const path = "admin/analytics";

export const getDashboardSummary = async () => {
  return await axiosInstance(options).get(`${path}/dashboard-summary`);
};

export const getUsageAnalytics = async () => {
  return await axiosInstance(options).get(`${path}/usage`);
};

export const getLearningOutcomes = async () => {
  return await axiosInstance(options).get(`${path}/learning-outcomes`);
};

export const getCommerceAnalytics = async () => {
  return await axiosInstance(options).get(`${path}/commerce`);
};
